import { gql } from "@apollo/client"

export const ADD_LOCATION_MUTATION = gql(`
mutation AddLocation($input: AddLocationInput!){
   addLocation (input:$input){
     __typename
   }
}`)